const getByPathname = (translate, pathname) => {
	switch (pathname) {
		case "/casino":
			return translate("casino.loading-casino");
		case "/provider":
			return translate("casino.loading-games");
		case "/casino-favorites":
			return translate("casino.loading-favorites");
		case "/casino/game":
			return translate("casino.loading-game");
		default:
			return translate("");
	}
};

const getByLoadingType = (translate, loadingType) => {
	switch (loadingType) {
		case "Casino":
			return translate("casino.loading-casino");
		case "LiveCasino":
			return translate("casino.loading-live-casino");
		default:
			return translate("");
	}
};

export const setLoadingName = (translate, loadingType) => {
	const type = loadingType || window?.location?.pathname;

	if (type.startsWith("/")) {
		return getByPathname(translate, type);
	}

	return getByLoadingType(translate, type);
};
